import { fold } from "../fable_modules/fable-library-js.4.19.3/List.js";
import { delay, indexed, iterate, toList } from "../fable_modules/fable-library-js.4.19.3/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.19.3/Range.js";

export const chunk = 32768;

export function base64Encode(input) {
    const bytes = new Uint8Array(input);
    const binaryString_1 = fold((binaryString, i) => {
        const subarray = bytes.subarray(i, i + chunk);
        return binaryString + (String.fromCharCode.apply(null, subarray));
    }, "", toList(rangeDouble(0, chunk, bytes.length - 1)));
    return btoa(binaryString_1);
}

export function base64Decode(base64String) {
    const binaryString = atob(base64String);
    const bytes = new Uint8Array(binaryString.length);
    iterate((tupledArg) => {
        const i = tupledArg[0] | 0;
        bytes[i]=(binaryString.charCodeAt(i));
    }, indexed(delay(() => binaryString.split(""))));
    return new Int16Array(bytes);
}

